import moment from "moment";

export const CampaignReportHeaders = [
  { label: "Date", key: "date" },
  { label: "Campaign", key: "campaign" },
  { label: "Type", key: "type" },
  { label: "Driver Name", key: "name" },
  { label: "Phone Number", key: "phone" },
  { label: "Metro", key: "metro" },
  { label: "Routes", key: "routes" },
  { label: "Status", key: "status" },
];

export function formatBCampaignReportTransactions(data) {
  const formattedData = data.map((item) => {
    const {
      campaign,
      username,
      name,
      phone,
      metro,
      routeCompleted,
      bonusStatus,
      date,
    } = item || {};

    return {
      campaign: campaign?.name || "-",
      type: campaign?.type || "-",
      name: name || "-",
      username: username || "-",
      phone: phone || "-",
      metro: metro || "-",
      routes: routeCompleted || "-",
      status: bonusStatus || "-",
      date: moment(date).format('MM-DD-YYYY hh:mm A'),
    };
  }) || [];

  return formattedData;
}